import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { identity } from 'lodash';

export function useEventParticipantNotifications(eventId, filter = identity) {
    const notifications =
        useSelector(
            (state) => state.events[eventId]?.notifications.eventMessage
        ) || [];

    return useMemo(
        () =>
            notifications
                .filter(
                    (notif) =>
                        _.get(notif, 'content.data.target', '').split('/')[0] ==
                        'participants'
                )
                .filter(filter),
        [notifications, filter]
    );
}
